import { render } from "./Services.vue?vue&type=template&id=540925f8&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=540925f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-540925f8"

export default script